export default __webpack_public_path__ + "static/media/inst-icon.42940f27.svg";